<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">Module's User 
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="exportusermodul()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <b-button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row >
        <b-col cols="5">
            <b-input-group>
                    <b-input-group-prepend><span class="pt-2 pr-2">Modul Name</span></b-input-group-prepend>
                    <b-form-select v-model="tblData.modulname" :plain="true" :options="modules" ></b-form-select>
            </b-input-group>
        </b-col>
        <b-col lg="2">
            <b-button class="btn btn-success" @click="refresh()" > <i class="fa fa-play"></i> Open</b-button>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        @row-clicked="rowClicked"
      >
        <template v-slot:cell(seqno)="data">
          {{ ((tblData.page-1)*tblData.limit)+data.index +1}}
        </template>
        <template v-slot:cell(isdeleted)="data">
          <span v-if="(data.item.isdeleted==1)">Inactive</span>
          <span v-else>Active</span>
        </template>

        <template v-slot:cell(action)="data">
          <div class="text-center">
          <a href="javascript:void(0)" @click.stop="view(data.item)">
            <i class="fa fa-search"></i> View
          </a>
          </div>
        </template>
      </b-table>
      <b-row>
        <b-col cols="5">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="2" >
          <b-input-group>
              <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend> 
              <b-form-select :options="[10, 15, 20, 25, 30, 35, 40, 45, 50]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
          </b-input-group>
        </b-col>        
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>      
    </b-card>
   <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>

  </div>
</template>

<style lang="scss" scoped>
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
</style>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import users from "../../apis/users";

toastr.init();

export default {
  data() {
    return {
      showFilter: false,
      showReport: false,
      reportUrl: null,
      modules:[],
      isLoading:false,
        model:{},
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: 'username',
        sortDesc: false
      },
      tblFields:[
          {
            key: "username",
            label: "Login Name",
            sortable: true
          },
          {
            key: "full_name",
            label: "Full Name",
            sortable: true
          },
          {
            key: "jabatan",
            label: "Job title"
          },
          {
            key: "departemen",
            label: "Department",
            sortable: true
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:60px",
            thClass: "text-center",
          }          
        ]      
    };
  },
  components: { Loading },  
  computed:{
        modulname() {
            return this.tblData.modulname;
        }
    },
  watch:{
        modulname: async function(newval) {
            this.refresh();
        }
    },  
  created: async function (){
      const list = await users.modul();
    this.modules = list.reduce((newArr,item) =>{
          newArr.push({value: item.code, text:item.name});
          return newArr;
      },[]);
  },
  methods: {
    data: async function(ctx) {
      this.isLoading=true;
      try {
        this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

        const list = await users.usermodul(this.tblData);      
        this.isLoading=false;              
        return list;
      } catch (error) {
          console.log('error : ', error);
          if (error.sql) {
              toastr.error(error.sql,'ERROR MESSAGE',10000);
          } else if (error.sqlMessage) {
              toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
          } else if (error.message) {
              toastr.error(error.message,'ERROR MESSAGE',10000);
          } else {
              toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
          }        
        
      }
    },
    rowClicked(record, index) {
        if ((this.model) && (this.model._rowVariant)) {
            delete this.model._rowVariant;
        }
        this.model = record;
        record._rowVariant= 'info';
        this.$forceUpdate();
    },    
    view: function(data){
      if (data.modulname) {
            let routeData = router.resolve({path: `menu/${data.modulname}/${data.username}`});
            window.open(routeData.href, '_blank');
      }
    },
    exportusermodul: async function() {
        this.isLoading=true;
        try {
            await users.exportusermodul(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },   

    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },    
    close(){
      router.push("home");
    },   
  }
};
</script>
